import React from "react";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {GamePlayMobileHeaderBarComponent} from "../../game-play-mobile-header-bar.component";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GamePlayMobileHeaderBarClockComponent} from "../../parts/clock/game-play-mobile-header-bar-clock.component";
import {NetPositionComponent} from "../../../../../common/parts/net-position/net-position.component";
import {GameDurationComponent} from "../../../../../common/parts/game-duration/game-duration.component";
import {observer} from "mobx-react";
import {ClockContainerBox} from "./boxes/clock-container.box";
import {TopSectionBox} from "./boxes/top-section.box";

interface UkGamePlayMobileHeaderBarComponentProps {
    gameContext: IGameContextViewModel;
    shouldShowNetPosition: boolean;
}

export const UkGamePlayMobileHeaderBarComponent = observer(
    class UkGamePlayMobileHeaderBarComponent extends OrbitComponent<UkGamePlayMobileHeaderBarComponentProps> {

        private _renderTopSection = () => {
            if(!this.props.shouldShowNetPosition) {

                return (
                    <TopSectionBox alignStart={true}>
                        <GamePlayMobileHeaderBarClockComponent/>
                    </TopSectionBox>
                );
            }

            return (
            <TopSectionBox alignStart={false}>
                <NetPositionComponent gameContext={this.props.gameContext}/>

                <ClockContainerBox>
                    <GamePlayMobileHeaderBarClockComponent/>
                </ClockContainerBox>

                <GameDurationComponent gameContext={this.props.gameContext}/>

            </TopSectionBox>);
        }

        render() {
            return (
                <GamePlayMobileHeaderBarComponent gameContext={this.props.gameContext}
                                                  renderTopLeftSection={this._renderTopSection}/>

            )
        }
    }
);